var map = {
	"./Bqxq40K4zojI9VBP630isdq7GqlmZOV4oWhnHC5eanGpV7iOacGP9Gba6D9slWTG-invert.svg": 1524,
	"./eaglebuildings-invert.svg": 7078
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8067;